import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFocusMacro: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFocusMacro"><Path d="M3.5 8V3.5H8M3.5 16V20.5H8M16 3.5H20.5V8M20.5 16V20.5H16M12 14.5V16.5M8.75 8.55204V10.9895C8.75 12.7845 10.2051 14.2395 12 14.2395C13.7949 14.2395 15.25 12.7845 15.25 10.9895V8.55204L13.3542 9.36454L12 8.01038L10.6458 9.36454L8.75 8.55204Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFocusMacro;
